import controller from './input-card.controller';
import template from './input-card.html';
import './input-card.scss';

export default {
	template,
	bindings: {
		disabled: '<?ngDisabled',
		model:    '<ngModel',
		options:  '=?',
		required: '<?ngRequired',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
